import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Admissions to Alumni",
    description: "Manage the complete student lifecycle from enquiry to graduation and beyond.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3L2 8l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M6 11v5c0 2 2.5 4 6 4s6-2 6-4v-5" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Semester Academics",
    description: "Course registration, credits, attendance, and CGPA tracking per programme.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="5" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 3v4M16 3v4M4 10h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Online Examinations",
    description: "Hall tickets, digital evaluation, result processing, and certificate issuance.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Fee & Finance",
    description: "Online payments, scholarships, concessions, and audit-ready financial reports.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const UerpIntroSection: React.FC = () => (
  <section className="wdev-intro" aria-labelledby="uerp-intro-title">
    <div className="container">
      <div className="wdev-intro__grid">
        <AnimatedSection className="wdev-intro__content">
          <span className="wdev-label wdev-label--purple">Higher Education ERP</span>
          <h2 id="uerp-intro-title" className="wdev-intro__title">
            University, Institution &amp; College ERP Software
          </h2>

          <p className="wdev-intro__text">
            Universities and colleges need more than spreadsheets to manage admissions, academics,
            examinations, and campus operations. Our ERP unifies student, faculty, and administrative
            workflows into one secure, scalable platform built for higher education.
          </p>
          <p className="wdev-intro__text">
            WebTech develops custom University and College ERP solutions in Bangalore — from online
            admissions and semester management to fee collection, library, hostel, placement, and
            accreditation-ready reporting for institutions of every size.
          </p>

          <div className="wdev-intro__highlights">
            {highlights.map((item) => (
              <div className="wdev-intro__highlight" key={item.title}>
                <div className="wdev-intro__highlight-icon">{item.icon}</div>
                <div>
                  <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                  <p className="wdev-intro__highlight-desc">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>

        <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
          <EstimateProjectForm />
        </AnimatedSection>
      </div>
    </div>
  </section>
);

export default UerpIntroSection;
